import { useState } from 'react'
import { useListings } from '@reservoir0x/reservoir-kit-ui'
import { getContractIdForSystemAndChainKey } from 'utils/multichain'
import { useMergeChainDataEffect } from 'hooks/liquidity/useMergeChainDataEffect'
import { BaseMultichainProps } from 'hooks/liquidity/mergeLiquidity.interface'

export interface MultichainListingsProps extends BaseMultichainProps<any[]> {
  address?: string
  is1155?: boolean
  isOwner?: boolean
}

export const MultichainListings = ({
  address,
  tokenId,
  is1155,
  isOwner,
  collection,
  systemId = '',
  onDataFetched,
}: MultichainListingsProps) => {
  const chainId = collection?.id
  const contractId = getContractIdForSystemAndChainKey(
    systemId,
    collection.routePrefix
  )
  const [userOnly, setUserOnly] = useState(false)
  const listingsQuery: Parameters<typeof useListings>['0'] = {
    maker: userOnly ? address : undefined,
    token: `${contractId}:${tokenId ?? ''.toString()}`,
    includeCriteriaMetadata: true,
    includeRawData: true,
    sortBy: 'price',
  }
  const {
    data: listings,
    fetchNextPage,
    mutate,
    isValidating,
    isFetchingPage,
    isLoading,
    error,
  } = useListings(listingsQuery, { revalidateFirstPage: true }, true, chainId)

  useMergeChainDataEffect({ data: listings, isLoading, error, onDataFetched })

  return null
}
